import useAppStore from "@/context/store";
import setCloseAds from "@/utils/closeAds";
import { useCallback } from "react";

export function useBannerVisibility() {
  const { globalBannerVisible, setGlobalBannerVisible } = useAppStore(
    ({ globalBannerVisible, setGlobalBannerVisible }) => ({
      globalBannerVisible,
      setGlobalBannerVisible,
    })
  );

  const onClose = useCallback(() => {
    setGlobalBannerVisible(false);
    useAppStore.setState({
      ads: null,
    });
  }, [setGlobalBannerVisible]);

  const onCloseAds = useCallback(
    (evt, record) => {
      evt.preventDefault();
      setCloseAds(record.material);
      onClose();
    },
    [onClose]
  );

  return {
    visible: globalBannerVisible,
    onClose,
    onCloseAds,
  };
}
